function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { px2rem, font, padding, getSpacing, getDisplay } from '../../utils/helpers';
var Button = styled.button(_templateObject(), function (_ref) {
  var theme = _ref.theme,
      as = _ref.as,
      variant = _ref.variant,
      backgroundType = _ref.backgroundType,
      tall = _ref.tall,
      fullWidth = _ref.fullWidth;
  var colors = theme.colors,
      text = theme.text,
      button = theme.button;
  var shared = button.shared;

  if (button[variant] === undefined || button[variant][backgroundType] === undefined) {
    return undefined;
  }

  var _button$variant$backg = button[variant][backgroundType],
      inactive = _button$variant$backg.inactive,
      hover = _button$variant$backg.hover,
      focus = _button$variant$backg.focus,
      active = _button$variant$backg.active,
      disabled = _button$variant$backg.disabled;
  return _extends({
    display: as === 'a' && 'inline-block',
    textAlign: as === 'a' && 'center'
  }, font(_extends({}, text.shared.bold, text.standard.xlarge)), padding(shared), {
    maxWidth: !fullWidth && px2rem(shared.maxWidth),
    borderStyle: 'solid',
    borderWidth: px2rem(shared.borderWidth),
    borderColor: colors[inactive.borderColor],
    borderRadius: px2rem(shared.borderRadius),
    backgroundColor: colors[inactive.backgroundColor],
    color: colors[inactive.color],
    height: tall && px2rem(shared.paddingTop + shared.paddingBottom + shared.lineHeight * 2 + shared.borderWidth * 2),
    verticalAlign: 'middle',
    overflow: 'hidden',
    transition: 'border-color .2s ease-in-out, background-color .2s ease-in-out, color .2s ease-in-out, outline-offset .2s ease-in-out',
    userSelect: 'none',
    textDecoration: as === 'a' && 'none',
    outlineOffset: px2rem(shared.outlineOffset),
    '&:not(:disabled)': {
      cursor: 'pointer'
    },
    '&:hover, &:focus': {
      borderColor: colors[hover.borderColor],
      backgroundColor: colors[hover.backgroundColor],
      color: colors[hover.color]
    },
    '&:focus': {
      outline: px2rem(shared.outlineWidth) + " solid " + colors[focus.outlineColor],
      outlineOffset: 0
    },
    '&:active': {
      borderColor: colors[active.borderColor],
      backgroundColor: colors[active.backgroundColor],
      color: colors[active.color]
    },
    '&:disabled': {
      borderColor: colors[disabled.borderColor],
      backgroundColor: colors[disabled.backgroundColor],
      color: colors[disabled.color]
    }
  });
}, getSpacing, getDisplay);
Button.propTypes = {
  variant: PropTypes.oneOf(['full', 'wired']),
  backgroundType: PropTypes.string,
  tall: PropTypes.bool,
  fullWidth: PropTypes.bool
};
Button.defaultProps = {
  variant: 'full',
  backgroundType: 'white',
  tall: false,
  fullWidth: false
};
export default Button;